import React, { forwardRef } from 'react';
import { classNames } from '@panwds/tailwindcss';
import { Handle } from './Handle.esm.js';

const defaultProps = {
    addClassName: '',
    disabled: false
};
/**
 * Lets the user toggle a setting on or off
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Toggle } from "@panwds/react-ui";
 * ```
 */
const ToggleSwitch = forwardRef((props, ref) => {
    const { addClassName, checked, dataMetrics, dataTestId, disabled, label, labelPlacement, title, needLabel = true, containerStyle = {}, ...passThrough } = props;
    const labelClassnames = `tw-max-w-[256px] tw-text-default ${disabled ? 'dark:tw-text-gray-600' : 'dark:tw-text-gray-300'}  tw-truncate tw-inline-block tw-align-top tw-font-lato tw-text-xs tw-font-normal tw-leading-4 ${title && 'tw-py-2'}`;
    const titleClassnames = 'tw-max-w-[256px] tw-text-default dark:tw-text-gray-100 tw-truncate tw-font-lato tw-text-xs tw-font-bold tw-leading-4 tw-mb-0.5';
    return (React.createElement("div", { className: "tw-inline-block", style: containerStyle },
        title && React.createElement("p", { className: titleClassnames }, title),
        labelPlacement === 'left' && React.createElement("span", { className: `${labelClassnames} tw-mr-2` }, label),
        React.createElement("button", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'toggle', disabled: disabled, ref: ref, role: "switch", type: "button", ...passThrough, "aria-checked": checked, className: classNames('tw-p-0 tw-relative tw-inline-flex tw-flex-shrink-0 tw-w-8 tw-h-4 tw-border-2 tw-border-transparent tw-rounded-full tw-transition-colors tw-ease-in-out tw-duration-200 focus:tw-outline focus:tw-outline-1 focus:tw-outline-blue-500 dark:focus:tw-outline-blue-300 focus:tw-outline-offset-2', title && 'tw-my-2', !disabled &&
                'hover:tw-outline hover:tw-outline-2 hover:tw-outline-blue-300 dark:hover:tw-outline-blue-400 dark:active:tw-outline-blue-300 tw-cursor-pointer', !disabled &&
                (checked
                    ? 'tw-bg-blue-600 dark:tw-bg-blue-700 hover:tw-bg-blue-700 dark:hover:tw-bg-blue-600 active:tw-bg-blue-800 dark:active:tw-bg-blue-500 '
                    : 'tw-bg-gray-600 hover:tw-bg-gray-700 dark:hover:tw-bg-gray-500 active:tw-bg-gray-800 dark:active:tw-bg-gray-400'), disabled && 'tw-bg-gray-400 tw-cursor-not-allowed dark:tw-bg-gray-900', addClassName) },
            React.createElement(Handle, { checked: checked, disabled: disabled })),
        labelPlacement === 'right' && React.createElement("span", { className: `${labelClassnames} tw-ml-2` }, label)));
});
ToggleSwitch.defaultProps = defaultProps;
ToggleSwitch.displayName = 'ToggleSwitch';

export { ToggleSwitch as Toggle, ToggleSwitch };
//# sourceMappingURL=ToggleSwitch.esm.js.map
